export default {
  title: {
    messageManagement: 'Message Management',
    notificationManagement: 'Notification Template Management',
    notificationEdit: 'Edit the Message',
    notificationAdd: 'Add a Message',
    notificationView: 'View the Message',
    layoutTemplateManagement: 'Template Management',
    layoutEdit: 'Edit the Template',
    layoutAdd: 'Add a Template',
    layoutView: 'View the Template'
  },
  label: {
    emailSenderAddress: 'From Address',
    toEmailAddress: 'Email Address',
    senderEmailCn: 'From Name (Chinese)',
    senderEmailEn: 'From Name (English)',
    subject: 'Email Subject',
    subjectCn: 'Email Subject (Chinese)',
    subjectEn: 'Email Subject (English)',
    emailEdit: 'Email Body',
    emailEditCn: 'Email Body (Chinese)',
    emailEditEn: 'Email Body (English)',
    emailTemplateCn: 'Email Template (Chinese)',
    emailTemplateEn: 'Email Template (English)',
    templateType: 'Message Type',
    templateName: 'Message Name',
    layoutName: 'Template Name',
    layoutTemplateList: 'Template Management',
    layoutTemplateLoad: 'Template',
    emailHeader: 'Email Header',
    emailFooter: 'Email Footer',
    backTemplatePage: 'Message Management',
    searchTemplateName: 'Message Name',
    searchTemplateType: 'Message Type',
    receiverLimit: 'Email Daily Limit Per Receiver',
    edit: 'Edit',
    delete: 'Delete',
    companyName: 'Company Name',
    searchUpLayout: 'Inherited from parent company'
  },
  tabMenu: {
    messageManagement: 'Message Management',
    layoutTemplateManagement: 'Template Management'
  },
  message: {
    sendSuccess: 'send success',
    deleteTip: 'Are you sure to delete it?',
    deleteLayout: 'Are you sure to delete the {company} - {name} template?'
  },
  btn: {
    sendEmailTestButton: 'Send a Test Email',
    cancel: 'Cancel',
    save: 'Save',
    send: 'Send'
  }
}
